import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';

function SizeGuide() {
  return (
    <Container className="mt-5">
      <h2 className="text-center mb-4">Size Guide</h2>

      {/* Display charts in even proportions */}
      <Row className="mb-4">
        {/* Children's size chart */}
        <Col xs={12} md={4} className="text-center">
          <h4>Children's Sizes</h4>
          <img
            src="https://ntrepid-bucketc13d4-dev.s3.us-east-1.amazonaws.com/assets/nTrepidDesign_Children2.JPG"
            alt="Children's Size Chart"
            className="img-fluid"
            style={{ maxWidth: '100%', height: 'auto' }}
          />
        </Col>

        {/* Women's size chart */}
        <Col xs={12} md={4} className="text-center">
          <h4>Women's Sizes</h4>
          <img
            src="https://ntrepid-bucketc13d4-dev.s3.us-east-1.amazonaws.com/assets/nTrepidDesign_Women.jpg"
            alt="Women's Size Chart"
            className="img-fluid"
            style={{ maxWidth: '100%', height: 'auto' }}
          />
        </Col>

        {/* Men's size chart */}
        <Col xs={12} md={4} className="text-center">
          <h4>Men's Sizes</h4>
          <img
            src="https://ntrepid-bucketc13d4-dev.s3.us-east-1.amazonaws.com/assets/nTrepidDesign_Men2.JPG"
            alt="Men's Size Chart"
            className="img-fluid"
            style={{ maxWidth: '100%', height: 'auto' }}
          />
        </Col>
      </Row>

      {/* Custom Outfits Information */}
      <div className="text-center mb-4">
        <p>
          Our catalog page is in progress. In the meantime, you can complete the measurement pdf forms below for custom outfits. Once completed, please email your size chart along with a picture of the preferred style to{' '}
          <a href="mailto:ntrepiddesign@outlook.com">ntrepiddesign@outlook.com</a>. We will schedule a video meeting with one of our tailors or seamstresses to review your custom outfit request or take additional measurements if necessary.
        </p>
      </div>

      {/* PDF Links */}
      <div className="text-center">
        <h4>Download Size Charts for Custom Outfits</h4>
        <Button
          variant="link"
          href="https://ntrepid-bucketc13d4-dev.s3.us-east-1.amazonaws.com/assets/NtrepidDesign_MensMeasurementChart2025.pdf"
          target="_blank"
        >
          Men's Custom Size Guide (PDF)
        </Button>
        <br />
        <Button
          variant="link"
          href="https://ntrepid-bucketc13d4-dev.s3.us-east-1.amazonaws.com/assets/NtrepidDesignMeasurment_Ladies.pdf"
          target="_blank"
        >
          Women's Custom Size Guide (PDF)
        </Button>
      </div>
    </Container>
  );
}

export default SizeGuide;
